import { z } from 'zod';

export const ORDER_ORGANIZATION_ROLE_SCHEMA = z.enum(['CUSTOMER', 'SUPPLIER', 'CARRIER', 'CUSTOM']);
export type ORDER_ORGANIZATION_ROLE = z.infer<typeof ORDER_ORGANIZATION_ROLE_SCHEMA>;

export const ORDER_ORGANIZATION_TRANSACTIONAL_ROLE_SCHEMA = z.enum(['DEBTOR', 'CREDITOR']);
export type ORDER_ORGANIZATION_TRANSACTIONAL_ROLE = z.infer<typeof ORDER_ORGANIZATION_TRANSACTIONAL_ROLE_SCHEMA>;
